import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import { Modal , Button } from 'react-bootstrap';
import RedirectToLogin from '../../../../utils/RedirectToLogin';
import { messages } from '../../../../utils/language-en.json';
import { getCurrentUser } from '../../../../services/authService';
import { updateStaffPositionsIncrease } from '../../../../services/staffService';
import { PayRatesContext } from '../../PayRates';
import moment from "moment";
import Select from '../../../Common/form/select';

function RaisePayRateEdit({ item }) {
  const payRatesContext = useContext(PayRatesContext);
  const [payRateIncrease, setPayRateIncrease] = useState({
    id: item.id,
    position_id: item.position_id,
    department_id: item.department_id,
    increase_regular_pay_rate: item.increase_regular_pay_rate,
    increase_travel_pay_rate: item.increase_travel_pay_rate,
    date: moment().format('YYYY-MM-DD')
  });

  useEffect(() => {
    setPayRateIncrease({
      id: item.id,
      position_id: item.position_id,
      department_id: item.department_id,
      increase_regular_pay_rate: item.increase_regular_pay_rate,
      increase_travel_pay_rate: item.increase_travel_pay_rate,
      date: moment().format('YYYY-MM-DD')
    })
  }, [item]);

  return (
    !getCurrentUser()
      ? <RedirectToLogin location={payRatesContext.props.location} />
      : <section className="RaisePayRateEdit">
          <div className="row">
            <div className="increase-form">
              <RenderPayRateInput
                label="Regular pay rate"
                name="increase_regular_pay_rate"
                payRateIncrease={payRateIncrease}
                actions={{setPayRateIncrease}}
              />
            </div>
            {item.position_id === 1 ?
              <div className="increase-form">
                <RenderPayRateInput
                  label="Travel pay rate"
                  name="increase_travel_pay_rate"
                  payRateIncrease={payRateIncrease}
                  actions={{setPayRateIncrease}}
                />
              </div> : null}
          </div>
        </section>
  )
}

function RenderPayRateInput({ label, name, payRateIncrease, actions }) {
  const [showModal, setShowModal] = useState(false);

  const increaseOptions =  [{ id: '', name: '' }];
  for (let i = 0.25; i <= 5; i=i+0.25) {
    increaseOptions.push(
      { id: i.toString(), name: i.toFixed(2) }
    )
  }

  const closeModal = () => {
    setShowModal(false);
  }

  const handleSavePayRates = async () => {
    const { data } = await updateStaffPositionsIncrease(payRateIncrease);
    const success = data.success;
    if (!success) {
      const errorMessage = data.message;
      toast.error(errorMessage);
      return
    }
    toast.success(messages.success.settingsPositionUpdated, { autoClose: 1000 });
    setShowModal(false);
    window.location.reload();
  }

  const handleChange = () => ({ currentTarget: input }) => {
    if (input.value !== '') {
      if (input.name === 'increase_regular_pay_rate') {
        actions.setPayRateIncrease({...payRateIncrease, 'increase_travel_pay_rate': undefined})
      } else {
        actions.setPayRateIncrease({...payRateIncrease, 'increase_regular_pay_rate': undefined})
      }
      actions.setPayRateIncrease({...payRateIncrease, [name]: input.value});
      setShowModal(true);
      input.value = '';
    }
  };

  return (
    <>
    <div className="form-group">
      <div className="d-flex flex-column-reverse">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">$</span>
          </div>
          <Select
            name={name}
            defaultClass={''}
            options={increaseOptions}
            onChange={handleChange()}
          />
        </div>
        <label htmlFor={name}>{label}</label>
      </div>
    </div>

    <Modal show={showModal} onHide={() => setShowModal(false)} className="modal-increase-payrate">
      <Modal.Header closeButton>
        <Modal.Title>
          Pay Rate Update
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="scroll-wrapper">
          <table className="table">
            <tbody>
              <tr>
                <td>
                <div className="form-group">
                  <p><strong>Are you sure you want to raise the pay rate? Doing this will update:</strong></p>
                  <div className="d-flex flex-column-reverse">
                    <ul>
                      <li>All Staff members in this position that are below the min new value</li>
                      <li>Rates in current assigned events after: <strong>{moment().format('YYYY-MM-DD')} 00:00</strong></li>
                    </ul>
                  </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>Cancel</Button>
        <Button variant="success" onClick={() => handleSavePayRates()}>Confirm</Button>
      </Modal.Footer>
    </Modal>
  </>
  )
}

export default RaisePayRateEdit
